// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"15c5be39","236":"bdc1ea39","329":"9dcc3ccc","564":"4c8bf6c3","634":"15c5be39"}[chunkId] + ".chunk.css";
};